/**
 * 存储localStorage
 */
export const setStorage = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStorage = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStorage = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

export const storageKey = {
	secrecy: 'quick_user_secrecy',
	user: 'quick_user_user',
	industry: 'quick_user_industry',
}


// WEBPACK FOOTER //
// ./src/utils/storage.js